import { render, staticRenderFns } from "./FilterAdmisiones.vue?vue&type=template&id=f652cde0"
import script from "./FilterAdmisiones.vue?vue&type=script&lang=js"
export * from "./FilterAdmisiones.vue?vue&type=script&lang=js"
import style0 from "./FilterAdmisiones.vue?vue&type=style&index=0&id=f652cde0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports